import { type DatePickerOption } from './types'

const DATE_PICKER_DAY_OPTION_PAD = 2
const DATE_PICKER_MAX_DAY = 31

export const datePickerGetDayOptions = (): DatePickerOption[] => {
  return Array.from(
    { length: DATE_PICKER_MAX_DAY },
    (_unusedValue, dayIndex) => {
      const day = dayIndex + 1

      return {
        text: String(day).padStart(DATE_PICKER_DAY_OPTION_PAD, '0'),
        value: day,
      }
    },
  )
}
